import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { FieldTypeTextSimpleComponent } from '../field-type-text/field-type-text-simple/field-type-text-simple.component';
import { FormsModule } from '@angular/forms';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { ValidateDocumentService } from '@shared/services/validate-document/validate-document.service';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';

@Component({
    selector: 'generate-document',
    templateUrl: './generate-document.component.html',
    standalone: true,
    imports: [AfTranslateDirective, FormsModule, FieldTypeTextSimpleComponent]
})
export class GenerateDocumentComponent implements OnInit {
  predefinedTemplate: any = this.dialogConfig.data.predefinedTemplate;
  isLanding: Boolean = this.customLanding.isLanding();
  concept: any = this.dialogConfig.data.concept;
  generateDocument: any = {
    document: {
      properties: {},
      name: '',
      templateName:''
    },
    documentName: {
      id:'1',
      required:  true,
      label: this.translate.instant('generate-document.name-document')
    }
  }

  constructor(private translate: AfTranslateFactory,
    private customLanding: CustomLandingFactory,
    private apiService: ApiServiceService,
    private modalService: ModalServiceService,
    private validateDocumentService: ValidateDocumentService,
    private dialogRef: DynamicDialogRef<GenerateDocumentComponent>,
    private dialogConfig: DynamicDialogConfig) { }

  ngOnInit(): void {
    if(this.predefinedTemplate){
      this.generateDocument.document.properties = this.predefinedTemplate;
      this.generateDocument.document.templateName = this.predefinedTemplate.name;
      this.generateDocument.document.name = this.predefinedTemplate.predefinedName;
      // let text: string = 'generate-document.export-form-data';
      // if(this.predefinedTemplate.from === 'fieldTemplate'){
      //   text = this.isLanding? 'generate-document.export-form-data-from-field-landing' : 'generate-document.export-form-data-from-field';
      // }
      let text = this.isLanding? 'generate-document.export-form-data-from-field-landing' : 'generate-document.export-form-data-from-field';
      this.generateDocument.textInfoTemplate =  this.translate.instant(text).replace('{template}',  this.generateDocument.document.templateName);
    }
  }

  itemSelected(e:any, type:any){
    this.generateDocument.document[type] = e.newValue;
  }

  checkNameOther(){
    this.apiService.add('documentobjects/existsdocinassociatedeval/'+this.concept.conceptObjectId, {name: this.generateDocument.document.name})
      .then((data:any)=>{
        if(!data){
          this.validateName();
        }else{
          this.showError(this.translate.instant('generate-document.exist-in-other'));
        }
      }, (errorData:any)=>{})
  }

  validateFields(){
    if(this.generateDocument.document.name !== ''){
      this.concept.productId === 'forms'? this.checkNameOther() : this.validateName();
    }else{
      this.showError();
    }
  }

  validateName(){
    let textValidate = this.validateUploadFiles(this.generateDocument.document.name +'.'+ this.predefinedTemplate.extension.toLowerCase(), this.concept.documentation.documents);
    if(textValidate === ''){
      this.generateDocument.documentName.error = false;
      this.handleAccept();
    }else{
      this.showError(textValidate);
    }
  }

  showError(textValidate:string=''){
    if(textValidate){
      this.generateDocument.documentName.errorText = this.translate.instant(textValidate);
    }
    this.generateDocument.documentName.error = true;
    this.modalService.errorModal({ text: this.translate.instant('documentation-list.error-configuration-add-document') });
  }

  validateUploadFiles(document:any, list:any){
    if(!(this.validateDocumentService.correctCharacters(document))){
      return 'rename-modal.invalid-document';
    }
    if(!(this.validateDocumentService.correctDocumentFormat(document))){
      return 'documentation-list.format-not-accepted';
    }
    if(this.validateDocumentService.duplicatedDocuments(document, list)){
      return 'documentation-list.duplicated-name-document';
    }
    if(!(this.validateDocumentService.nameLength(document))){
      return 'up-document.error-name';
    }
    return '';
  }

  handleAccept(){
    this.dialogRef.close({
      result: 'ok',
      name:  this.generateDocument.document.name+'.'+(this.generateDocument.document.properties.extension.toLowerCase()),
      url: 'documentobjects/fromComplianceDocumentTemplate/'+this.concept.conceptObjectId+'/'+this.generateDocument.document.properties.id
    })
  }

  handleDismiss(){
    this.dialogRef.close({result: 'cancel'});
  }

}
